<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >

      <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
        <a-form-model-item label="示例名称">
          <a-input :maxLength=50 v-model="form.name" @change="(e) => { formErr.name=''}" @blur="(e) => {  form.name = e.target.value.trim();}"/>
        </a-form-model-item>

        <a-form-model-item ref="type" label="所属板块" prop="type" :help="formErr.type" :validateStatus='!formErr.type||formErr.type==""?"":"error"'>
          <a-select v-model="form.type" class="seachs" placeholder="请选择" max allowClear>
            <a-select-option :value="item.id" v-for="item in seachList">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item ref="content" label="示例内容" prop="content" :help="formErr.content" :validateStatus='!formErr.content||formErr.content==""?"":"error"' >
          <a-input type="textarea"
                   :maxLength=300
                   v-model="form.content"
                   @change="(e) => { formErr.content=''}"
                   @blur="(e) => {  form.content = e.target.value.trim();}" />
        </a-form-model-item>
      </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    import moment from 'moment';
    export default {
        name: "newForm",
        // props: ["visible","title","editId"],
        props: {
            visible:{type: Boolean,},
            title:{type: String,},
            editId:{type: [String, Number],},
            seachList:{type:Array,  default: () => []},
        },
        data() {
            return {

                seleList:[],
                drawerConfig ,
                dateFormat: 'YYYY-MM-DD HH:mm:ss',
                form: {name:'',
                  content:"",
                  type:"",
                },
                formErr: {
                  name:'',
                  content:"",
                  type:"",
                },
                rules: {
                  content: [{required: true, message: "请输入示例内容",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.content)}  , trigger: "blur"  },],
                  type: [{required: true, message: "请选择所属板块",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.type)}  , trigger: "blur"  },],
                    },
                layout: {
                    labelCol: { span:4},
                    wrapperCol: { span:16},
                },
            };
        },
        watch:{
            visible:function(){
            },
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        let data=res.data.data
                        this.form = data
                        this.form.id=a
                    })
                } else {
                    this.form.id = ''

                }
            }
        },
        mounted(){
            // this.getFormData()
        },
        methods: {
            // getFormData(){
            //     API.service.ADD_DATA().then(res => {
            //         this.seleList={
            //             category:res.data.data.category,
            //             status:res.data.data.status,
            //         }
            //     })
            // },
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={
                  name:'',
                  content:"",
                  type:"",
                }
              this.form = {
                name: '',
                content: "",
                type: "",
              },
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
             //    let subData=JSON.parse(JSON.stringify(this.form))
             // alert(subData.release_time!=""&&subData.release_time!=null)
               this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))

                      this.form.id == '' || this.form.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT

                      submitForm(url, subData).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
</style>
